import React from 'react';
import useRUMView from 'common-datadog/useRUMView';
import Screen from '../Screen';
import Form from '../Form';
import ButtonPrimary from '../ButtonPrimary';
import useForm from './useForm';
import ScrollableIframe from '../ScrollableIframe';
import useCapsUser from '../../resources/capsUsers/read';
import Disclaimers from '../Disclaimers';
import { LEGAL_DISCLAIMER } from './constants';

const RevolverCardHolderAgreement = () => {
  useRUMView('revolver-card-holder-agreement');
  const { data: capsUser } = useCapsUser();
  const documentId = capsUser.relationships.cardholder_agreement.data.id;

  const {
    form,
    handleSubmit,
    isSubmitting,
  } = useForm();

  return (
    <Screen
      header={(
        <>
          You&apos;re approved!
          <br />
          Finalize your ExpressWay Cardholder Agreement.
        </>
      )}
      subheader="Please review the Cardholder Agreement and agree to terms by clicking “Accept Offer” below."
    >
      <Form form={form} onSubmit={handleSubmit} sx={{ flex: 1 }}>
        <ScrollableIframe
          name="hasViewedIframe"
          src={`/documents/${documentId}?embed=true`}
          iframeTitle="WebBank DigniFi Card Holder Agreement"
        />
        <Disclaimers>
          {LEGAL_DISCLAIMER}
        </Disclaimers>
        <ButtonPrimary isLoading={isSubmitting}>
          Accept Offer
        </ButtonPrimary>
      </Form>
    </Screen>
  );
};

export default RevolverCardHolderAgreement;
